import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_160w_single');
    return (
        <div className="sp-160-single-G">
            <div className="info-box">
                <p className="desc">{t('G_desc')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/solar-panel-160w-single/7.jpg"
                    srcPad="/responsive/picture/solar-panel-160w-single/7_768.jpg"
                    srcMobile="/responsive/picture/solar-panel-160w-single/7_768.jpg"
                    alt={t('G_desc')}
                />
            </div>
        </div>
    );
}
